import { render, staticRenderFns } from "./wrap.vue?vue&type=template&id=5e33a871&scoped=true"
import script from "./wrap.vue?vue&type=script&lang=js"
export * from "./wrap.vue?vue&type=script&lang=js"
import style0 from "./wrap.vue?vue&type=style&index=0&id=5e33a871&prod&lang=scss"
import style1 from "./wrap.vue?vue&type=style&index=1&id=5e33a871&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e33a871",
  null
  
)

export default component.exports